import "../css/main.css"; // single CSS entry for Tailwind and project styles

import { $ } from "./shared/jquery-globals";

// Import Swiper core and modules
import { Swiper } from "swiper";
import {
  Navigation,
  Pagination,
  Autoplay,
  Zoom,
  Thumbs,
  EffectFade,
} from "swiper/modules";

// Import Swiper CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "swiper/css/thumbs";
import "swiper/css/effect-fade";

// Import Plyr Autoplay module
import PlyrAutoplay from "./modules/plyr-autoplay";
import Cart from "./modules/cart";
import ProductAutocomplete from "./modules/product-autocomplete.js";
import AffiliateTracking from "./modules/affiliate-tracking.js";

// Ready logic
$(async function () {
  // Initialize Affiliate Tracking
  new AffiliateTracking();

  //follow tailwind breakpoints
  var isMobile = $(window).width() < 768;

  const headerTopBar = $(".header-topbar");
  const headerBar = $(".header-bar");
  const headerMenu = $(".header-menu");

  // Header scroll behavior for both mobile and desktop
  // Check if elements exist
  if (headerBar.length && headerTopBar.length && headerMenu.length) {
    const headerTopBarHeight = headerTopBar.outerHeight();
    const headerBarHeight = headerBar.outerHeight();
    const totalHeaderHeight = headerTopBarHeight + headerBarHeight;
    let lastScrollTop = 0;
    let isHeaderVisible = true;

    // Add transition class to header elements
    headerTopBar.addClass("transition-all duration-300");
    headerBar.addClass("transition-all duration-300");
    headerMenu.addClass("transition-all duration-300");

    // Ensure header is fixed on all devices to avoid layout shift
    headerBar.addClass("fixed left-0 right-0");
    // Keep topbar fixed as well; when hidden we translate it out of view
    headerTopBar.addClass("fixed top-0 left-0 right-0 z-[95]");

    $(window).on("scroll", function () {
      const scrollTop = $(window).scrollTop();
      const scrollDirection = scrollTop > lastScrollTop ? "down" : "up";
      lastScrollTop = scrollTop;

      // Check if header should always show
      const shouldAlwaysShow = headerBar.hasClass("header-bar-always-show");

      if (scrollTop > totalHeaderHeight) {
        // When scrolled past total header height, hide topbar and stick header to top
        headerTopBar.addClass("opacity-0 -translate-y-full");
        headerBar.css("top", "0");

        if (shouldAlwaysShow) {
          // Always show behavior - keep header fixed and visible
          headerBar
            .addClass("fixed left-0 right-0 translate-y-0")
            .removeClass("relative -translate-y-full");
          headerMenu.removeClass("opacity-0 -translate-y-full z-0");
          // Don't add padding to body since page-content already has padding-top
          isHeaderVisible = true;
        } else {
          // Hide/show behavior based on scroll direction
          if (scrollDirection === "down" && isHeaderVisible) {
            // Scrolling down - hide header
            headerBar
              .addClass("fixed left-0 right-0 -translate-y-full")
              .removeClass("relative translate-y-0");
            headerMenu.addClass("opacity-0 -translate-y-full z-0");
            isHeaderVisible = false;
            // Don't add padding to body since page-content already has padding-top
          } else if (scrollDirection === "up" && !isHeaderVisible) {
            // Scrolling up - show header
            headerBar
              .addClass("fixed left-0 right-0 translate-y-0")
              .removeClass("relative -translate-y-full");
            headerMenu.removeClass("opacity-0 -translate-y-full z-0");
            isHeaderVisible = true;
            // Don't add padding to body since page-content already has padding-top
          } else if (scrollDirection === "up" && isHeaderVisible) {
            // Already visible, just ensure it's in the right state
            headerBar
              .addClass("fixed left-0 right-0 translate-y-0")
              .removeClass("relative -translate-y-full");
            headerMenu.removeClass("opacity-0 -translate-y-full z-0");
            // Don't add padding to body since page-content already has padding-top
          } else if (scrollDirection === "down" && !isHeaderVisible) {
            // Already hidden, just ensure it stays hidden
            headerBar
              .addClass("fixed left-0 right-0 -translate-y-full")
              .removeClass("relative translate-y-0");
            headerMenu.addClass("opacity-0 -translate-y-full z-0");
            // Don't add padding to body since page-content already has padding-top
          }
        }
      } else {
        // When scrolled back to top (within total header height)
        headerTopBar.removeClass("opacity-0 -translate-y-full");
        // Keep header fixed at top on all devices
        headerBar
          .addClass("fixed left-0 right-0 translate-y-0")
          .removeClass("relative -translate-y-full");
        // Restore header position below topbar
        headerBar.css("top", headerTopBarHeight + "px");
        // Don't add or reset padding since page-content handles its own padding
        headerMenu.removeClass("opacity-0 -translate-y-full z-0");
        isHeaderVisible = true;
      }
    });
  }

  // Mobile menu functionality
  if (isMobile) {
    // add event listener to mobile-menu-trigger (using class selector for multiple triggers)
    $(".mobile-menu-trigger").on("click", function (e) {
      e.preventDefault();
      openMobileDrawer();
    });

    // Function to open mobile drawer
    function openMobileDrawer() {
      // Create overlay if it doesn't exist
      if (!$("#mobile-menu-overlay").length) {
        $("body").append(
          '<div id="mobile-menu-overlay" class="fixed inset-0 bg-black bg-opacity-30 z-[99] hidden transition-opacity duration-300"></div>'
        );
      }

      // Show overlay
      $("#mobile-menu-overlay").removeClass("hidden").addClass("opacity-80");

      // Setup drawer menu
      $("#header-menu")
        .removeClass("hidden")
        .addClass(
          "fixed top-0 left-0 z-[100] h-full bg-white overflow-y-auto w-80 max-w-[80vw] transform -translate-x-full transition-transform duration-300"
        );

      // Slide in drawer
      setTimeout(() => {
        $("#header-menu")
          .removeClass("-translate-x-full")
          .addClass("translate-x-0");
      }, 10);

      // Prevent body scroll
      $("body").addClass("overflow-hidden");

      // Add close event listeners
      setupMobileDrawerCloseEvents();
    }

    // Function to close mobile drawer
    function closeMobileDrawer() {
      // Slide out drawer
      $("#header-menu")
        .removeClass("translate-x-0")
        .addClass("-translate-x-full");

      // Hide overlay
      $("#mobile-menu-overlay")
        .removeClass("opacity-100")
        .addClass("opacity-0");

      // Clean up after animation
      setTimeout(() => {
        $("#header-menu")
          .addClass("hidden")
          .removeClass(
            "fixed top-0 left-0 z-[100] h-full bg-white overflow-y-auto w-80 max-w-[80vw] transform -translate-x-full translate-x-0 transition-transform duration-300"
          );

        $("#mobile-menu-overlay")
          .addClass("hidden")
          .removeClass("opacity-100 opacity-0");
        $("body").removeClass("overflow-hidden");
      }, 300);
    }

    // Function to setup close event listeners
    function setupMobileDrawerCloseEvents() {
      // Close on overlay click
      $("#mobile-menu-overlay")
        .off("click")
        .on("click", function () {
          closeMobileDrawer();
        });

      // Close on ESC key
      $(document)
        .off("keydown.mobileDrawer")
        .on("keydown.mobileDrawer", function (e) {
          if (e.key === "Escape") {
            closeMobileDrawer();
          }
        });

      // Add close button if it doesn't exist
      if (!$("#header-menu .mobile-drawer-close").length) {
        $("#header-menu").prepend(`
          <div class="flex items-center justify-between p-4 border-b border-gray-200">
            <h3 class="text-lg font-semibold">Danh mục</h3>
            <button class="mobile-drawer-close p-2 hover:bg-gray-100 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        `);
      }

      // Close on close button click
      $(".mobile-drawer-close")
        .off("click")
        .on("click", function () {
          closeMobileDrawer();
        });
    }
  }

  // add event listener to header-bar-search-trigger
  $("#header-bar-search-trigger").on("click", function () {
    const $searchFormContainer = $("#product-search-form-container");
    const isOpening = !$searchFormContainer.hasClass("product-search-show");

    $searchFormContainer.toggleClass("product-search-show");
    headerBar.attr(
      "data-search",
      headerBar.attr("data-search") === "open" ? "closed" : "open"
    );

    if (isOpening) {
      // Opening search - focus input
      setTimeout(() => {
        $("#product-search-autocomplete").trigger("focus");
      }, 200);
    } else {
      // Closing search - clear results and input
      const $searchInput = $("#product-search-autocomplete");
      const $fullResults = $("#product-search-full-results");
      if ($searchInput.length && $fullResults.length) {
        $searchInput.val("");
        $fullResults.addClass("hidden");
      }
    }
  });

  // add event listener to header-bar-search-backdrop
  $("#header-bar-search-backdrop").on("click", function () {
    $("#product-search-form-container").removeClass("product-search-show");
    headerBar.attr("data-search", "closed");

    // Clear search results and input when closing full search
    const $searchInput = $("#product-search-autocomplete");
    const $fullResults = $("#product-search-full-results");
    if ($searchInput.length && $fullResults.length) {
      $searchInput.val("");
      $fullResults.addClass("hidden");
    }
  });

  // add event listener to header-bar-search-close
  $("#header-bar-search-close").on("click", function () {
    $("#product-search-form-container").removeClass("product-search-show");
    headerBar.attr("data-search", "closed");

    // Clear search results and input when closing full search
    const $searchInput = $("#product-search-autocomplete");
    const $fullResults = $("#product-search-full-results");
    if ($searchInput.length && $fullResults.length) {
      $searchInput.val("");
      $fullResults.addClass("hidden");
    }
  });

  document.querySelectorAll(".banner-swiper").forEach((el) => {
    //flag to detect slider (normal) or grid (no thumb, no interaction, no navigation, no pagination, no interaction)
    const galleryLayout = el.dataset.galleryLayout || "slider";

    const direction = el.dataset.direction || "horizontal";
    const slidesMobile =
      el.dataset.slidesMobile && el.dataset.slidesMobile === "auto"
        ? "auto"
        : parseInt(el.dataset.slidesMobile || "1");

    const slidesDesktop =
      el.dataset.slidesDesktop && el.dataset.slidesDesktop === "auto"
        ? "auto"
        : parseInt(el.dataset.slidesDesktop || "1");
    const gapMobile = parseInt(el.dataset.gapMobile || "0");
    const gapDesktop = parseInt(el.dataset.gapDesktop || "0");
    const autoplay = el.dataset.autoplay === "1";
    const delay = parseInt(el.dataset.delay || "5000");
    const loop = el.dataset.loop === "1";
    const lazy = el.dataset.lazy === "1";
    const zoom = parseInt(el.dataset.zoom || "0");
    const navigation = el.dataset.navigation === "1";
    const pagination = el.dataset.pagination === "1";
    const effect = el.dataset.effect || "slide";
    const speed = parseInt(
      el.dataset.speed || effect === "fade" ? "1000" : "500"
    );
    const crossFade = false; // Hard code để tránh mix hình

    // ✅ BƯỚC 1: Khởi tạo THUMBS SWIPER trước (nếu có)
    let thumbsSwiper = null; // Khai báo biến ở ngoài để có thể truy cập
    const thumbsId = el.dataset.thumbsId;
    if (thumbsId && galleryLayout === "slider") {
      const thumbsEl = document.getElementById(thumbsId);
      if (thumbsEl) {
        // Lấy số lượng slides cho thumb từ data-attribute để linh hoạt hơn
        const thumbsSlidesPerView = parseInt(
          thumbsEl.dataset.slidesDesktop || "5"
        );
        const thumbsNavigation = thumbsEl.dataset.navigation === "1";
        const thumbsDirection = thumbsEl.dataset.direction || "horizontal";
        const thumbsGap = parseInt(thumbsEl.dataset.gap || "8");

        // Helper to keep vertical thumbs height in sync with main gallery
        const syncThumbsHeight = () => {
          if (thumbsDirection !== "vertical") return;
          // Measure main gallery height
          const mainHeight = Math.round(
            el.getBoundingClientRect().height || el.clientHeight || 0
          );
          if (!mainHeight || mainHeight <= 0) return;
          // Apply height to thumbnails container and update
          thumbsEl.style.height = mainHeight + "px";
          thumbsEl.style.maxHeight = mainHeight + "px";
          thumbsEl.style.overflowY = "auto";
          if (thumbsSwiper && typeof thumbsSwiper.updateSize === "function") {
            thumbsSwiper.updateSize();
            thumbsSwiper.updateSlides();
            thumbsSwiper.updateProgress();
            thumbsSwiper.updateSlidesClasses();
            thumbsSwiper.update();
          }
        };

        thumbsSwiper = new Swiper(thumbsEl, {
          modules: [Navigation],
          observer: true,
          observeParents: true,

          direction: thumbsDirection,
          slidesPerView: thumbsSlidesPerView,
          spaceBetween: thumbsGap,
          watchSlidesProgress: true, // Rất quan trọng để class 'swiper-slide-thumb-active' hoạt động
          freeMode: true, // Cho phép lướt thumb mượt mà
          loop: false, // Thumb không nên loop
          navigation: thumbsNavigation
            ? {
                nextEl: thumbsEl.querySelector(".swiper-button-next"),
                prevEl: thumbsEl.querySelector(".swiper-button-prev"),
              }
            : false,
        });

        // Initial sync and observers for vertical thumbs
        if (thumbsDirection === "vertical") {
          // Try immediately (in case main already has height)
          syncThumbsHeight();

          // On window resize
          window.addEventListener("resize", syncThumbsHeight);

          // When main images/videos finish loading
          const onMediaLoaded = () => syncThumbsHeight();
          el.querySelectorAll("img").forEach((img) => {
            if (img.complete) {
              // Defer to next tick to ensure layout is settled
              setTimeout(syncThumbsHeight, 0);
            } else {
              img.addEventListener("load", onMediaLoaded);
            }
          });
          el.querySelectorAll("video").forEach((video) => {
            if (video.readyState >= 1) {
              setTimeout(syncThumbsHeight, 0);
            } else {
              video.addEventListener("loadedmetadata", onMediaLoaded);
              video.addEventListener("loadeddata", onMediaLoaded);
            }
          });
        }
      }
    }

    // ✅ BƯỚC 2: Khởi tạo MAIN SWIPER và liên kết với thumbsSwiper
    new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay, Zoom, Thumbs, EffectFade],
      on: {
        init: function (sw) {
          const swiperWrapper = el.querySelector(".swiper-wrapper");
          if (swiperWrapper) {
            const foundGridClass = swiperWrapper.classList
              .toString()
              .split(" ")
              .filter((c) => c.startsWith("grid"));

            if (foundGridClass.length > 0) {
              swiperWrapper.classList.remove(...foundGridClass);
            }
          }

          // Observe videos in this swiper
          if (window.plyrAutoplay) {
            window.plyrAutoplay.observeNewVideos(el);
          }

          // Ensure wrapper translate is reset to avoid first-run horizontal shift
          if (effect === "fade") {
            if (sw.wrapperEl && sw.wrapperEl.style) {
              sw.wrapperEl.style.transform = "translate3d(0,0,0)";
            }

            // Prime ALL slides: set initial hidden state so first change animates
            sw.slides.forEach((slide) => {
              const c = slide.querySelector(".banner-hero-content-inner");
              if (c) {
                c.style.transition =
                  "opacity 0.9s ease 0.5s, transform 0.9s ease 0.5s";
                c.style.opacity = "0";
                c.style.transform = "translateY(20px)";
              }
              const b = slide.querySelector(".banner-hero-buttons");
              if (b) {
                b.style.transition =
                  "opacity 1s ease 0.7s, transform 1s ease 0.7s";
                b.style.opacity = "0";
                b.style.transform = "translateY(28px)";
              }
            });

            // Initialize hero content position for active slide
            const activeSlide = sw.slides[sw.activeIndex];
            if (activeSlide) {
              const heroContent = activeSlide.querySelector(
                ".banner-hero-content-inner"
              );
              if (heroContent) {
                // Start hidden and slide in on first render too
                heroContent.style.opacity = "0";
                heroContent.style.transform = "translateY(20px)";
                heroContent.style.transition =
                  "opacity 0.9s ease 0.3s, transform 0.9s ease 0.3s";

                setTimeout(() => {
                  heroContent.style.opacity = "1";
                  heroContent.style.transform = "translateY(0)";
                }, 1000);
              }

              // Ensure hero buttons are in resting position on init
              const heroButtons = activeSlide.querySelector(
                ".banner-hero-buttons"
              );
              if (heroButtons) {
                // Staggered parallax for first render
                heroButtons.style.opacity = "0";
                heroButtons.style.transform = "translateY(28px)";
                heroButtons.style.transition =
                  "opacity 1s ease 0.5s, transform 1s ease 0.5s";

                setTimeout(() => {
                  heroButtons.style.opacity = "1";
                  heroButtons.style.transform = "translateY(0)";
                }, 1200);
              }
            }
          }

          // Keep vertical thumbnails height in sync with main on init
          const thumbsEl = el.dataset.thumbsId
            ? document.getElementById(el.dataset.thumbsId)
            : null;
          const thumbsDirection = thumbsEl?.dataset?.direction || "";
          if (thumbsEl && thumbsDirection === "vertical") {
            // Measure and apply
            const mainHeight = Math.round(
              el.getBoundingClientRect().height || el.clientHeight || 0
            );
            if (mainHeight > 0) {
              thumbsEl.style.height = mainHeight + "px";
              thumbsEl.style.maxHeight = mainHeight + "px";
              thumbsEl.style.overflowY = "auto";
              if (thumbsEl.swiper) {
                thumbsEl.swiper.updateSize();
                thumbsEl.swiper.update();
              }
            }
          }
        },
        slideChangeTransitionStart: function (sw) {
          // Animate hero content on fade effect
          if (effect === "fade") {
            // Hide previous slide hero content (move down)
            const prevSlide = sw.slides[sw.previousIndex];
            if (prevSlide) {
              const prevHeroContent = prevSlide.querySelector(
                ".banner-hero-content-inner"
              );
              if (prevHeroContent) {
                prevHeroContent.style.opacity = "0";
                prevHeroContent.style.transform = "translateY(20px)";
              }

              // Hide previous slide hero buttons
              const prevHeroButtons = prevSlide.querySelector(
                ".banner-hero-buttons"
              );
              if (prevHeroButtons) {
                prevHeroButtons.style.opacity = "0";
                prevHeroButtons.style.transform = "translateY(28px)";
              }
            }

            // Show next slide hero content (move up from bottom)
            const nextSlide = sw.slides[sw.activeIndex];
            if (nextSlide) {
              const nextHeroContent = nextSlide.querySelector(
                ".banner-hero-content-inner"
              );
              if (nextHeroContent) {
                // Ensure transition is present, then set initial state
                nextHeroContent.style.transition =
                  "opacity 0.9s ease 0.5s, transform 0.9s ease 0.5s";
                nextHeroContent.style.opacity = "0";
                nextHeroContent.style.transform = "translateY(20px)";

                // Force reflow so the above state is committed before animating
                void nextHeroContent.offsetHeight;

                // Animate to normal position
                window.requestAnimationFrame(() => {
                  nextHeroContent.style.opacity = "1";
                  nextHeroContent.style.transform = "translateY(0)";
                });
              }

              // Parallax-like stagger for hero buttons
              const nextHeroButtons = nextSlide.querySelector(
                ".banner-hero-buttons"
              );
              if (nextHeroButtons) {
                // Ensure transition is present, then set initial state
                nextHeroButtons.style.transition =
                  "opacity 1s ease 0.7s, transform 1s ease 0.7s"; // start later for parallax
                nextHeroButtons.style.opacity = "0";
                nextHeroButtons.style.transform = "translateY(28px)"; // slightly deeper

                // Force reflow before animating
                void nextHeroButtons.offsetHeight;

                window.requestAnimationFrame(() => {
                  nextHeroButtons.style.opacity = "1";
                  nextHeroButtons.style.transform = "translateY(0)";
                });
              }
            }
          }
        },
        slideChange: function () {
          // Note: Video.js autoplay handles slide changes automatically via IntersectionObserver
          // Also ensure vertical thumbs follow main height on change
          const thumbsEl = el.dataset.thumbsId
            ? document.getElementById(el.dataset.thumbsId)
            : null;
          const thumbsDirection = thumbsEl?.dataset?.direction || "";
          if (thumbsEl && thumbsDirection === "vertical") {
            const mainHeight = Math.round(
              el.getBoundingClientRect().height || el.clientHeight || 0
            );
            if (mainHeight > 0) {
              thumbsEl.style.height = mainHeight + "px";
              thumbsEl.style.maxHeight = mainHeight + "px";
              thumbsEl.style.overflowY = "auto";
              if (thumbsEl.swiper) {
                thumbsEl.swiper.updateSize();
                thumbsEl.swiper.update();
              }
            }
          }
        },
        // Rely on CSS keyframes for zoom-out; no JS transforms to avoid jitter

        zoomChange: function (swiper, scale, imageEl) {
          // Lấy đường dẫn ảnh chất lượng cao từ data-attribute
          const highResSrc = imageEl.getAttribute("data-zoom-src");

          // Nếu không có data-zoom-src thì không làm gì cả
          if (!highResSrc) return;

          // KIỂM TRA: Nếu đang zoom VÀO (scale > 1) và ảnh hiện tại chưa phải là ảnh chất lượng cao
          if (scale > 1 && imageEl.getAttribute("src") !== highResSrc) {
            // Lưu lại ảnh gốc (ảnh nhỏ) để có thể quay lại
            if (!imageEl.hasAttribute("data-original-src")) {
              imageEl.setAttribute("data-original-src", imageEl.src);
            }
            // Thay thế src bằng ảnh chất lượng cao
            imageEl.src = highResSrc;
          }
          // KIỂM TRA: Nếu đang zoom RA (scale <= 1) và đang dùng ảnh chất lượng cao
          else if (scale <= 1 && imageEl.hasAttribute("data-original-src")) {
            // Quay trở lại ảnh gốc (ảnh nhỏ)
            imageEl.src = imageEl.getAttribute("data-original-src");
          }
        },
      },
      direction: direction,
      slidesPerView: slidesMobile,
      spaceBetween: gapDesktop,
      breakpoints: {
        0: {
          slidesPerView: slidesMobile,
          spaceBetween: gapMobile,
        },
        768: {
          slidesPerView: slidesDesktop,
          spaceBetween: gapDesktop,
        },
      },
      loop: thumbsSwiper ? false : loop, // Disable loop when thumbs exist to prevent sync issues
      autoplay: autoplay ? { delay } : false,
      pagination: pagination
        ? {
            el: el.querySelector(".swiper-pagination"),
            clickable: true,
          }
        : false,
      navigation: navigation
        ? {
            nextEl: el.dataset.swiperButtonNext
              ? document.querySelector("." + el.dataset.swiperButtonNext)
              : el.querySelector(".swiper-button-next"),
            prevEl: el.dataset.swiperButtonPrev
              ? document.querySelector("." + el.dataset.swiperButtonPrev)
              : el.querySelector(".swiper-button-prev"),
          }
        : false,
      lazy: lazy,

      // ✅ Đây là cách liên kết đúng và duy nhất bạn cần
      // Chỉ thêm vào nếu thumbsSwiper đã được khởi tạo thành công
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,

      effect: effect,
      speed: speed,
      // Use native fade effect only; custom transforms removed
      fadeEffect:
        effect === "fade"
          ? {
              crossFade: crossFade,
            }
          : undefined,
      zoom: zoom > 0 ? { maxRatio: zoom, panOnMouseMove: true } : undefined,
    });
  });

  // Initialize Cart module for header & footer cart badge
  if ($(".cart-trigger").length) {
    window.cartModule = new Cart();
  }

  // Mini-cart drawer logic: intercept .cart-trigger with data-minicart="1"
  // Lazy-mount a React island (CartIndex) inside a drawer without navigating
  $(document).on(
    "click",
    ".cart-trigger[data-minicart='1']",
    async function (e) {
      e.preventDefault();

      // Ensure a single drawer container exists
      const drawerId = "minicart-drawer";
      let $drawer = $("#" + drawerId);
      if (!$drawer.length) {
        $("body").append(
          `<div id="${drawerId}" class="fixed inset-y-0 right-0 z-[100] w-full sm:w-[92vw] sm:max-w-md bg-white shadow-xl transform translate-x-full transition-transform duration-300">
            <div class="minicart-header flex items-center justify-between px-4 py-3 border-b border-b-gray-200">
              <h3 class="text-lg font-semibold">Giỏ hàng</h3>
              <button class="minicart-close p-2 rounded-full hover:bg-gray-100" aria-label="Đóng">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            </div>
            <div class="minicart-content overflow-y-auto h-[calc(100%-56px)]" id="minicart-react-root"></div>
          </div>
          <div id="${drawerId}-backdrop" class="fixed inset-0 bg-black/30 z-[99] hidden opacity-0 transition-opacity duration-300"></div>`
        );
        $drawer = $("#" + drawerId);
      }

      const $backdrop = $("#" + drawerId + "-backdrop");
      const reactRootEl = document.getElementById("minicart-react-root");

      // Lazy import React island only when needed
      try {
        if (!window.CartDrawerReact) {
          await import(
            /* webpackChunkName: "cart-drawer" */ "../react/cart-drawer"
          );
        }
        if (reactRootEl && !reactRootEl._minicartRoot) {
          // Mount once per page lifetime; reuse for subsequent opens
          // Đợi translations load xong
          const root = await window.CartDrawerReact.render(reactRootEl);
          reactRootEl._minicartRoot = root;
        }
      } catch (err) {
        console.error("Failed to load CartDrawerReact:", err);
        // Fallback: navigate to /cart
        window.location.href = "/cart";
        return;
      }

      // Show drawer and backdrop
      $backdrop.removeClass("hidden");
      // Lock body scroll on mobile
      $("body").addClass("overflow-hidden");
      window.requestAnimationFrame(() => {
        $backdrop.addClass("opacity-100").removeClass("opacity-0");
        $drawer.removeClass("translate-x-full").addClass("translate-x-0");
      });

      // Notify React island to refresh cart data
      window.dispatchEvent(new CustomEvent("minicart:open"));

      // Close handlers
      function closeDrawer() {
        $drawer.addClass("translate-x-full").removeClass("translate-x-0");
        $backdrop.removeClass("opacity-100").addClass("opacity-0");
        // Restore body scroll
        $("body").removeClass("overflow-hidden");
        setTimeout(() => $backdrop.addClass("hidden"), 300);
        // Notify React island to stop polling
        window.dispatchEvent(new CustomEvent("minicart:close"));
      }

      $(document)
        .off("click.minicart-backdrop")
        .on(
          "click.minicart-backdrop",
          "#" + drawerId + "-backdrop",
          closeDrawer
        );
      $drawer
        .off("click.minicart-close")
        .on("click.minicart-close", ".minicart-close", closeDrawer);
      $(document)
        .off("keydown.minicart-esc")
        .on("keydown.minicart-esc", function (evt) {
          if (evt.key === "Escape") closeDrawer();
        });
    }
  );

  // Initialize ProductAutocomplete if search input exists
  if ($("#product-search-autocomplete").length) {
    window.productAutocomplete = new ProductAutocomplete();
  }

  // Initialize Plyr Autoplay module
  if (document.querySelectorAll("video").length) {
    window.plyrAutoplay = new PlyrAutoplay();
    // Delay initialization to ensure DOM is ready
    setTimeout(() => {
      window.plyrAutoplay.init();
    }, 1000);
  }

});

// Listen for content updates to observe new videos
window.addEventListener("contentUpdated", (event) => {
  if (window.plyrAutoplay) {
    // Observe new videos in the updated content
    const container = event.detail?.container || document;
    window.plyrAutoplay.observeNewVideos(container);
  }
});

// Listen for banner updates specifically
window.addEventListener("bannerUpdated", (event) => {
  if (window.plyrAutoplay) {
    const container = event.detail?.container || document;
    window.plyrAutoplay.observeNewVideos(container);
  }
});
